import { render, staticRenderFns } from "./NavigationHistory.vue?vue&type=template&id=5e0b476e"
import script from "./NavigationHistory.vue?vue&type=script&lang=js"
export * from "./NavigationHistory.vue?vue&type=script&lang=js"
import style0 from "./NavigationHistory.vue?vue&type=style&index=0&id=5e0b476e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports